<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Faixa "Visão Geral / Pós-Publicação": descrição da seção ativa, abas de
// seção do relatório e os três cards do indicador selecionado.
defineProps({
  modelValue: { type: String, default: '' },
  sections: { type: Array, default: () => [] },
  activeSection: { type: Object, default: () => ({}) },
  sectionDescription: { type: String, default: '' },
  scopeBadge: { type: String, default: '' },
  cards: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="border-b border-lais-border-rule px-4 py-4 sm:px-6 lg:px-10">
    <div class="flex flex-col gap-4">
      <div class="rounded-lais border border-lais-border-soft bg-white p-4">
        <p
          class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          Visão Geral
        </p>
        <p class="mt-1 text-[13px] leading-relaxed text-lais-text-body">
          Confira dados sobre as preferências dos seus leads e otimize suas
          campanhas e captações.
        </p>
      </div>

      <div class="flex flex-col gap-1">
        <p
          class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          Pós-Publicação
        </p>
        <h2 class="font-redHatDisplay text-[18px] font-semibold text-lais-text">
          {{ activeSection.label }}
        </h2>
        <p
          class="max-w-[760px] text-[13px] leading-relaxed text-lais-text-body"
        >
          {{ sectionDescription }}
        </p>
        <p class="text-[12px] font-semibold text-lais-primary">
          {{ scopeBadge }}
        </p>
      </div>

      <div class="flex items-center gap-6 overflow-x-auto no-scrollbar">
        <button
          v-for="section in sections"
          :key="section.value"
          type="button"
          class="relative shrink-0 py-3 text-[14px] font-semibold transition-colors"
          :class="
            modelValue === section.value
              ? 'text-lais-primary'
              : 'text-lais-text-muted hover:text-lais-text-body'
          "
          :aria-pressed="modelValue === section.value"
          @click="emit('update:modelValue', section.value)"
        >
          {{ section.label }}
          <span
            v-if="modelValue === section.value"
            class="absolute bottom-0 left-0 right-0 h-[3px] rounded-t bg-lais-primary"
          />
        </button>
      </div>

      <div class="grid gap-3 md:grid-cols-3">
        <div
          v-for="card in cards"
          :key="card.title"
          class="rounded-lais border p-4"
          :class="
            card.highlight
              ? 'border-lais-primary bg-lais-primary-50'
              : 'border-lais-border-soft bg-white'
          "
        >
          <p
            class="text-[12px] font-semibold"
            :class="
              card.highlight ? 'text-lais-primary' : 'text-lais-text-muted'
            "
          >
            {{ card.title }}
          </p>
          <p
            class="mt-2 font-redHatDisplay text-[24px] font-semibold text-lais-text"
          >
            {{ card.value }}
          </p>
          <p class="mt-1 text-[12px] leading-relaxed text-lais-text-body">
            {{ card.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
